import { RecordSource, RelayFeatureFlags } from 'relay-runtime';
import LiveResolverStore

// @ts-ignore
from 'relay-runtime/lib/store/experimental-live-resolvers/LiveResolverStore';
import RelayDataID from '@atlassian/relay-data-id';
import RelayMissingFieldHandlers from '@atlassian/relay-missing-field-handlers';
import { createNetwork, network as defaultNetwork } from '@atlassian/relay-network';
import RelayScheduler from '@atlassian/relay-scheduler';
var createStore = function createStore(source, options) {
  RelayFeatureFlags.ENABLE_RELAY_RESOLVERS = true;
  return new LiveResolverStore(source, options);
};
export function getDefaultRelayEnvironmentConfig(_ref) {
  var log = _ref.log,
    requiredFieldLogger = _ref.requiredFieldLogger,
    network = _ref.network,
    networkOptions = _ref.networkOptions,
    getDataID = _ref.getDataID,
    recordSource = _ref.recordSource;
  return {
    configName: 'Atlassian Graphql Gateway',
    network: network || getEnvironmentNetwork(networkOptions),
    store: createStore(recordSource || new RecordSource(), {
      log: log !== null && log !== void 0 ? log : undefined,
      getDataID: getDataID !== null && getDataID !== void 0 ? getDataID : RelayDataID
    }),
    log: log,
    relayFieldLogger: requiredFieldLogger,
    getDataID: getDataID !== null && getDataID !== void 0 ? getDataID : RelayDataID,
    scheduler: RelayScheduler,
    missingFieldHandlers: RelayMissingFieldHandlers
  };
}
export function getSharedRelayEnvironmentConfig(_ref2) {
  var log = _ref2.log,
    requiredFieldLogger = _ref2.requiredFieldLogger,
    networkOptions = _ref2.networkOptions,
    getDataID = _ref2.getDataID,
    recordSource = _ref2.recordSource;
  return {
    configName: 'Atlassian Shared Graphql Gateway',
    network: getEnvironmentNetwork(networkOptions),
    store: createStore(recordSource || new RecordSource(), {
      log: log !== null && log !== void 0 ? log : undefined,
      getDataID: getDataID !== null && getDataID !== void 0 ? getDataID : RelayDataID
    }),
    log: log,
    relayFieldLogger: requiredFieldLogger,
    getDataID: getDataID !== null && getDataID !== void 0 ? getDataID : RelayDataID,
    scheduler: RelayScheduler,
    missingFieldHandlers: RelayMissingFieldHandlers
  };
}
var getEnvironmentNetwork = function getEnvironmentNetwork(environmentOptions) {
  if (environmentOptions) {
    return createNetwork(environmentOptions);
  }
  return defaultNetwork;
};